import { render, staticRenderFns } from "./PowerupSearchEditComponent.vue?vue&type=template&id=04c9cdbe&scoped=true"
import script from "./PowerupSearchEditComponent.vue?vue&type=script&lang=js"
export * from "./PowerupSearchEditComponent.vue?vue&type=script&lang=js"
import style0 from "./PowerupSearchEditComponent.vue?vue&type=style&index=0&id=04c9cdbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9cdbe",
  null
  
)

export default component.exports